import { PageWrapper } from '@ardoq/page-layout';
import { filterParam } from 'router/declarative/filterParam';
import { uriComponentParam } from 'router/declarative/paramRegistry';
import {
  IndexRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { AppModules } from '../appContainer/types';
import { fixedResourcePermissionBoundary } from '../router/declarative/declarativePermissionBoundary';

export const routes = {
  path: '/field-details',
  appModule: AppModules.FIELD_DETAILS,
  content: async () => PageWrapper,
  children: [
    {
      path: { layout: true },
      content: fixedResourcePermissionBoundary(
        { pageName: 'Fields' },
        'organization/manage_global_fields',
        'organization'
      ),
      children: [
        {
          path: '/:fieldId',
          searchParams: { filter: filterParam, query: uriComponentParam },
          children: [
            {
              path: { index: true },
              content: async (): IndexRouteContent =>
                (await import('./FieldDetailsPage')).FieldDetailsPage,
            },
            {
              path: '/delete',
              searchParams: { fieldDeleteSection: uriComponentParam },
              content: async (): PathRouteContent =>
                (await import('./pages/fieldDelete/FieldDeletePage'))
                  .FieldDeletePage,
              children: [],
            },
            {
              path: '/history',
              content: async (): PathRouteContent =>
                (await import('./pages/fieldHistory/FieldHistoryPage'))
                  .FieldHistoryPage,
              children: [],
            },
          ],
        },
      ],
    },
  ],
} as const satisfies RouteNode;
